export default function PayrollCompleteness({ value }) {
  if (!value || value.complete !== false) return null;
  const periods = [...new Set((value.pending || []).map(row => row.period))];
  return <div role="status" className="rounded border border-amber-300 bg-amber-50 p-3 text-sm text-amber-950">
    <strong>Coste laboral incompleto.</strong> Los resultados incluyen solo componentes contabilizados. Faltan fuentes o revisiones.
    {periods.length > 0 && <span> Periodos: {periods.join(", ")}.</span>}
    <a href="/nominas" className="ml-2 underline">Revisar nóminas</a>
  </div>;
}
